export default () => {
  const $input = $('<input>')
    .css({ position: 'fixed', left: '-9999px' })
    .appendTo('body')

  $input.focus()

  setTimeout(() => { $input.blur().remove() }, 10)
}
